// extracted by mini-css-extract-plugin
module.exports = {"themeNameWrapper":"vPJ56Hxx","themeName":"r1PCtO05","logoWrapper":"s9K1h9Cz","changeRow":"Zjd6F7lv","changeValue":"AWjUAyEJ","catalystsWrapper":"yps6kIYB","moreCount":"UhddI2Ap"};